import { CircularProgress } from "@mui/material";
import {
  CloseCircleOutline,
  MailOutline,
  ShieldCheckmarkOutline,
} from "@raresail/react-ionicons";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { Logo } from "../../../assets/svg/Svgs";
import { API_VERIFY_EMAIL } from "../../../constants/apis";
import { primary50 } from "../../../constants/colors";
import {
  APP_NAME,
  FAILED,
  PENDING,
  SUCCESS,
} from "../../../constants/constants";
import useSet from "../../../hooks/common/useSet";
import { Button } from "../../common/Button";
import { IconBox } from "../../elements/Elements";
import { showConfetti } from "../../elements/ConfettiView";

export const VerifyPage = () => {
  const { search } = useLocation();
  const token = new URLSearchParams(search)?.get("token");
  const { submitting, uploadData, success, error } = useSet();
  const status =
    (submitting && PENDING) || (success && SUCCESS) || (error && FAILED);

  const { title, icon: Icon, content, component } = getContent(status);

  useEffect(() => {
    if (token) {
      uploadData({
        api: API_VERIFY_EMAIL,
        params: { token },
        onSuccess: showConfetti,
      });
    }
  }, []);

  return (
    <div className="lightBg vh100 flexCenter dotBg">
      <Wrapper className="p20 whiteBg r15 animate flexColumn textCenter flexCenter">
        <div className="flexNullCenter gap10">
          <img src={Logo} width={30} height={30} alt={APP_NAME} />
          <div className="extraBold font20 main">everpesa</div>
        </div>

        <div className="textDark flexColumn gap10 flexCenter">
          <div className="mb5">
            <IconBox icon={Icon} size={50} />
          </div>
          <div className="semiBold font20">{title}</div>
          <div>{content}</div>
        </div>
        {component}
      </Wrapper>
    </div>
  );
};

const getContent = (status: any) => {
  let icon = MailOutline,
    content,
    title,
    component,
    color = primary50;

  switch (status) {
    case PENDING:
      content = "Please wait while we verify your email address";
      title = "Verifying Email";
      component = <CircularProgress size={30} />;
      break;
    case SUCCESS:
      content = "Your email address was successfully verified";
      title = "Email Verified";
      icon = ShieldCheckmarkOutline;
      color = "green";
      component = (
        <Link to={"/auth/login"}>
          <Button>Continue to login</Button>
        </Link>
      );
      break;
    case FAILED:
      content = "Unfortunately we failed to verify your email address";
      title = "Verification Failed";
      icon = CloseCircleOutline;
      color = "red";
      break;

    default:
      break;
  }
  return { icon, content, title, color, component };
};

const Wrapper = styled.div`
  gap: 30px;
  width: 500px;
  min-height: 400px;
  @media (max-width: 960px) {
    width: 100%;
    margin: 20px;
  }
`;
